import React, { FC } from 'react';
import {
  FormControl as MuiFormControl,
  FormHelperText as MuiFormHelperText,
  InputLabel as MuiInputLabel,
  Theme,
  styled,
} from '@material-ui/core';
import { FormControlProps } from '@material-ui/core/FormControl';

type Props = FormControlProps & {
  label?: string;
  helperText?: React.ReactNode;
  id: string;
  children: React.ReactElement;
  required?: boolean;
};

const StyledFormControl = styled(MuiFormControl)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

const StyledInputLabel = styled(MuiInputLabel)<Theme>(({ theme }) => ({
  position: 'relative',
  transform: 'none',
  marginBottom: theme.spacing(2),
  color: theme.palette.offblack,
  fontSize: theme.typography.body1.fontSize,
}));

const StyledRequiredIndicator = styled('span')<Theme>(({ theme }) => ({
  marginLeft: theme.spacing(1),
  color: theme.palette.primary.main,
  fontWeight: 700,
}));

const StyledHelperText = styled(MuiFormHelperText)<Theme>(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
}));

const FormControl: FC<Props> = ({
  id,
  label,
  helperText,
  children,
  className,
  required = false,
  fullWidth = true,
}) => {
  return (
    <StyledFormControl className={className} fullWidth>
      {label && (
        <StyledInputLabel htmlFor={id}>
          {label}
          {required && <StyledRequiredIndicator>*</StyledRequiredIndicator>}
        </StyledInputLabel>
      )}
      {React.cloneElement(children, { id })}
      {helperText && <StyledHelperText>{helperText}</StyledHelperText>}
    </StyledFormControl>
  );
};

export default FormControl;
